import { render } from "./MenuModal.vue?vue&type=template&id=60175a0d&scoped=true&ts=true"
import script from "./MenuModal.vue?vue&type=script&lang=ts"
export * from "./MenuModal.vue?vue&type=script&lang=ts"

import "./MenuModal.vue?vue&type=style&index=0&id=60175a0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60175a0d"]])

export default __exports__